import React, { useState, useEffect } from 'react';
import CellEditable from '../containers/CellEditable';
import TextField from '@material-ui/core/TextField';
import CustomSwitch from '../../../components/Button/CustomSwitch';
import { Switch } from '@material-ui/core';

const variables = [
	/*{ key: 'account_vat_company', label: 'Société' },
	{
		key: 'account_vat_site',
		label: 'Code Etablissement',
		desc: '(max 3 caractères)',
		maxLength: 3,
	},*/
	{
		key: 'account_vat_ecriturenum',
		label: 'Dernière EcritureNum',
		desc: "(il s'incrémente à chaque export)",
		type: 'number',
	},
	{
		key: 'account_vat_validdate',
		label: 'FEC | ValidDate',
		desc: "Par défaut aujourd'hui",
	},
	{ key: 'account_vat_journal', label: 'Code du journal' },
	{ key: 'account_vat_journallib', label: 'Libellé du journal' },
	//{ key: 'account_vat_typepiece', label: 'Type de pièce' },
	//{ key: 'account_vat_devise', label: 'Devise' },
	{ key: 'account_vat_discount', label: 'Compte remises charges' },
	{ key: 'account_vat__discount', label: 'Compte remises contrepartie' },
	{ key: 'account_vat_offered', label: 'Compte offerts charges' },
	{ key: 'account_vat__offered', label: 'Compte offerts contrepartie' },
	{ key: 'account_vat_customer_account', label: 'Compte client (par défaut)' },
	{
		key: 'account_vat_customer_account_show_debit',
		label: 'Compte auxiliaire au DEBIT',
		type: 'boolean',
	},
	{ key: 'account_vat_achats', label: 'Compte Achats (par défaut)' },
	{
		key: 'account_vat_ventes',
		label: 'Compte Ventes hors caisse (par défaut)',
	},
	{
		key: 'account_vat_tips',
		label: 'Compte trop-perçus / pourboires',
		desc: '(ex: 467000)',
	},
	{
		key: 'account_vat_regulation_account',
		label: 'Compte de régulation',
		desc: '(notifier les écarts de règlement en fin de service)',
	},
	{
		key: 'account_vat_cashfloat_debit',
		label: 'Compte de mise à disposition du fond de caisse',
		desc: ' DEBIT (ex: 530000)',
	},
	{
		key: 'account_vat_cashfloat_credit',
		label: 'Compte de mise à disposition du fond de caisse',
		desc: 'CREDIT (ex: 580000) ',
	},
];

export default function GlobalSettings({ vatKeys, onSave }) {
	const [settings, setSettings] = useState({});
	useEffect(() => {
		setSettings(vatKeys);
	}, [vatKeys]);

	const onChange = (key, value) => {
		setSettings({ ...settings, [key]: value });
	};

	const onBlur = e => {
		const key = e.target.name;
		if (
			(key === 'account_vat_cashfloat_debit' ||
				key === 'account_vat_cashfloat_credit') &&
			(!settings['account_vat_cashfloat_credit'] ||
				!settings['account_vat_cashfloat_debit']) &&
			(settings['account_vat_cashfloat_credit'] ||
				settings['account_vat_cashfloat_debit'])
		) {
			alert(
				'Pour une configuration effective sur les comtpes de fond de caisse, les 2 comptes (DEBIT et CREDIT) doivent être renseignés'
			);
		}
	};

	return (
		<div className="vat-settings-keys-configuration">
			{variables.map((v, i) => {
				return (
					<div className="keys-container" key={i}>
						<span className="key-container-label">
							{v.label} {v.desc || ''} :{' '}
						</span>
						{v.type == 'select' ? (
							<select onChange={e => onChange(v.key, e.target.value)}>
								{v.options.map(o => (
									<option value={o.value}>{o.label}</option>
								))}
							</select>
						) : v.type == 'boolean' ? (
							<Switch
								checked={settings[v.key] == 1}
								onChange={e => onChange(v.key, e.target.checked ? 1 : 0)}
							/>
						) : (
							<TextField
								name={v.key}
								value={settings[v.key]}
								label={v.label}
								onChange={e => onChange(v.key, e.target.value)}
								variant="outlined"
								inputProps={{ maxlength: v.maxLength }}
								type={v.type || 'text'}
								onBlur={onBlur}
							/>
						)}
					</div>
				);
			})}
			<div className="vat-settings-btn">
				<button
					className={`btn-vat-settings`}
					onClick={() => {
						onSave(settings);
					}}>
					Enregistrer
				</button>
			</div>
		</div>
	);
}
